"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../../common/APLabelWithText"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _WithdrawTemplateFormContainer = _interopRequireDefault(require("../WithdrawTemplateForm/WithdrawTemplateFormContainer"));
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _numberFormatter = require("../../../helpers/numberFormatter");
var _withdrawHelper = require("../../../helpers/withdrawHelper");
var _config = _interopRequireDefault(require("../../../config"));
require("./WithdrawFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('withdraw-form');
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('slide-pane');
var WithdrawFormComponent = /*#__PURE__*/function (_React$Component) {
  function WithdrawFormComponent(props) {
    var _this;
    _classCallCheck(this, WithdrawFormComponent);
    _this = _callSuper(this, WithdrawFormComponent, [props]);
    _defineProperty(_this, "getInitialState", function () {
      return {
        position: null,
        product: {},
        errorMessage: ''
      };
    });
    _defineProperty(_this, "selectProduct", function (productId) {
      var _this$props = _this.props,
        selectWithdrawProduct = _this$props.selectWithdrawProduct,
        products = _this$props.products;
      var product = products.find(function (product) {
        return product.ProductId === productId;
      });
      if (product) {
        var position = _this.getPosition(product.Product);
        selectWithdrawProduct(product.ProductId);
        _this.setState({
          position: position,
          product: product
        });
      } else {
        _this.setState(_this.getInitialState());
      }
    });
    _defineProperty(_this, "getPosition", function (productId) {
      return _this.props.positions.find(function (position) {
        return position.ProductSymbol === productId;
      });
    });
    _defineProperty(_this, "onAmountChange", function (amount) {
      var product = _this.state.product;
      var _this$props2 = _this.props,
        withdrawInfo = _this$props2.withdrawInfo,
        template = _this$props2.withdrawInfo.template;
      var AccountProviderId = (0, _get["default"])(template, 'AccountProviderId') || (0, _get["default"])(withdrawInfo, 'AccountProviderId');
      if (!isNaN(amount)) {
        _this.props.getWithdrawFee(product.ProductId, amount, AccountProviderId);
      }
    });
    _defineProperty(_this, "doSubmit", function (values) {
      var t = _this.props.t;
      var _this$state$position = _this.state.position,
        Amount = _this$state$position.Amount,
        Hold = _this$state$position.Hold;
      var _this$props3 = _this.props,
        _this$props3$withdraw = _this$props3.withdrawInfo,
        fee = _this$props3$withdraw.withdrawFee,
        template = _this$props3$withdraw.template,
        submitWithdraw = _this$props3.submitWithdraw;
      var AccountProviderId = template.AccountProviderId || _this.props.withdrawInfo.AccountProviderId;
      var amount = parseFloat(values.Amount);
      var balance = (0, _withdrawHelper.getAvailableBalance)(Amount, Hold);
      if (amount <= balance) {
        values.Amount = (0, _withdrawHelper.getTotalWithdrawValue)(balance, values.Amount, fee);
      } else {
        _this.setState({
          errorMessage: t('You have insufficient balance')
        });
        return;
      }
      return submitWithdraw(_objectSpread(_objectSpread({}, values), {}, {
        AccountProviderId: AccountProviderId,
        ProductId: _this.state.product.ProductId
      }));
    });
    _defineProperty(_this, "getTotal", function (balance, amount, fee) {
      var t = _this.props.t;
      var total = (0, _withdrawHelper.getTotalRender)(balance, amount, fee);
      return total || total === 0 ? total : t('Insufficient funds');
    });
    _defineProperty(_this, "getInfoText", function (value) {
      var product = _this.state.product;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('currency')
      }, (0, _numberFormatter.formatNumberToLocale)(value, product && product.Product)), ' ', product && product.Product);
    });
    _this.state = _this.getInitialState();
    return _this;
  }
  _inherits(WithdrawFormComponent, _React$Component);
  return _createClass(WithdrawFormComponent, [{
    key: "componenDidMount",
    value: function componenDidMount() {
      var product = this.props.product;
      this.selectProduct(product.ProductId);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$state = this.state,
        product = _this$state.product,
        _this$state$position2 = _this$state.position,
        Amount = _this$state$position2.Amount,
        Hold = _this$state$position2.Hold,
        errorMessage = _this$state.errorMessage;
      var _this$props4 = this.props,
        handleSubmit = _this$props4.handleSubmit,
        submitting = _this$props4.submitting,
        withdrawInfo = _this$props4.withdrawInfo,
        amountValue = _this$props4.amountValue,
        invalid = _this$props4.invalid,
        selectWithdrawTemplate = _this$props4.selectWithdrawTemplate,
        hideFees = _this$props4.hideFees;
      var balance = (0, _withdrawHelper.getAvailableBalance)(Amount, Hold);
      var total = this.getTotal(balance, amountValue, withdrawInfo.withdrawFee);
      var balanceText = this.getInfoText(balance);
      var feeText = this.getInfoText(withdrawInfo.withdrawFee);
      var totalText = this.getInfoText(total);
      var receivedText = (0, _withdrawHelper.getTotalWithdrawValue)(balance, amountValue, withdrawInfo.withdrawFee);
      var showTemplateTypeSelect = withdrawInfo.templateTypes.length > 1 && !Object.keys(withdrawInfo.templateInfo).length && !withdrawInfo.isLoading;
      var templateTypes = [{
        value: '',
        label: 'Select an option'
      }].concat(_toConsumableArray(withdrawInfo.templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template[_config["default"].Withdraw.AccountProviderDisplayKey]
        };
      })));
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit(this.doSubmit),
        className: slidePaneClasses('body')
      }, withdrawInfo.withdrawStatus.success ? /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('success')
      }, t('Your withdraw ticket was created successfully.')) : /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('form-body')
      }, withdrawInfo.error && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error-text')
      }, t(withdrawInfo.error)), withdrawInfo.isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        customClass: baseClasses
      }), showTemplateTypeSelect && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('Select an option to continue the withdraw process')), /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "TemplateType",
        customClass: baseClasses(),
        label: t('Options for withdraw'),
        onSelect: function onSelect(value) {
          return selectWithdrawTemplate(product.ProductId, value);
        },
        options: templateTypes
      })), /*#__PURE__*/_react["default"].createElement(_WithdrawTemplateFormContainer["default"], {
        submitting: submitting,
        invalid: invalid,
        baseClasses: baseClasses,
        balance: balance,
        onAmountChange: this.onAmountChange,
        errorMessage: errorMessage
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('section')
      }, product && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Balance:'),
        text: balanceText,
        dataTest: "Balance:",
        customClass: baseClasses()
      }), !hideFees && /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Fee:'),
        text: feeText,
        dataTest: "Fee:",
        customClass: baseClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Total:'),
        text: totalText,
        dataTest: "Total:",
        customClass: baseClasses()
      }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
        label: t('Received:'),
        text: receivedText,
        dataTest: "Received:",
        customClass: baseClasses()
      }))))));
    }
  }]);
}(_react["default"].Component);
WithdrawFormComponent.defaultProps = {
  withdrawInfo: {
    templateInfo: {},
    template: {},
    isLoading: false,
    error: '',
    TemplateForm: {},
    withdrawStatus: {},
    getWithdrawFee: function getWithdrawFee() {}
  }
};
WithdrawFormComponent.propTypes = {
  handleSubmit: _propTypes["default"].func,
  getWithdrawFee: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  selectWithdrawProduct: _propTypes["default"].func.isRequired,
  products: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    Product: _propTypes["default"].string,
    ProductId: _propTypes["default"].number
  })).isRequired,
  withdrawInfo: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object.isRequired,
    template: _propTypes["default"].object.isRequired,
    isLoading: _propTypes["default"].bool.isRequired,
    error: _propTypes["default"].string,
    TemplateForm: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
    withdrawStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    }).isRequired
  }),
  VerificationRequiredComponent: _propTypes["default"].element
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(WithdrawFormComponent);